import { User } from "firebase/auth";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth } from './firebase';


const Profile = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true)

  function signOut() {
    return auth.signOut();
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
      setIsLoading(false);
    });

    return unsubscribe;
  }, []);

  if (isLoading) {
    return (<>Loading...</>)
  }

  if (!currentUser) {
    return <Navigate to="/" />
  }
  
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-4 text-center">
          <p>Welcome <em className="text-decoration-underline">{currentUser.email}</em>. You are logged in!</p>
          <div className="d-grid gap-2">
            <button type="submit" className="btn btn-primary pt-3 pb-3" onClick={(_) => signOut()}>Logout</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;